import {HeaderButton, IconName} from '@aboutyou/ui-components';
import React from 'react';

interface IconMetaNavigationItemProps {
  className?: string;
  dataTestId: string;
  count?: number;
  saleIndication?: {color: string};
  icon: IconName;
  label: string;
  dataAttributes?: Record<string, string>;
  onClick: React.MouseEventHandler;
  badgeOffset?: {
    top: number;
    right: number;
  };
}

export const IconMetaNavigationItem: React.FC<IconMetaNavigationItemProps> = ({
  className,
  dataTestId,
  count,
  icon,
  label,
  onClick,
  dataAttributes,
  saleIndication,
  badgeOffset,
}) => {
  const badgeDefaultOffset = {
    top: 1,
    right: 2,
  };

  const handleOnClick = (e: React.MouseEvent) => {
    onClick(e);
  };

  return (
    <HeaderButton
      className={className}
      data-testid={dataTestId}
      asset={icon}
      aria-label={label}
      onClick={handleOnClick}
      isCheckout={false}
      iconSize="S"
      count={count}
      showBadge={Boolean(count)}
      badgeOffset={badgeOffset ?? badgeDefaultOffset}
      badgeColor={saleIndication?.color}
      {...(dataAttributes || {})}
    />
  );
};
